import { render, staticRenderFns } from "./corner3.vue?vue&type=template&id=4c0451de&scoped=true&"
import script from "./corner3.vue?vue&type=script&lang=js&"
export * from "./corner3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0451de",
  null
  
)

export default component.exports